module.exports = __webpack_public_path__ + "static/10-dd23f7268d60db41c7f613d8de821776.png";